/**
 * Variant picker → history.replaceState au lieu de pushState.
 *
 * Sans ça : chaque clic sur un autre variant pousse une entrée dans l'historique,
 * donc le bouton "Retour" du navigateur fait défiler tous les variants visités
 * avant de revenir à la vraie page précédente.
 *
 * Avec ça : on intercepte le clic, on remplace l'URL courante via location.replace()
 * → la page se recharge pour afficher le nouveau variant, mais l'entrée d'historique
 * est SUBSTITUÉE au lieu d'être empilée. Le "Retour" revient direct à la page d'avant.
 *
 * Cible : tous les <a> dans [data-ps-tcg-variant-picker]
 * (TriPack, Booster, TCG card, OnePiece, Naruto, Lorcana).
 */
(function () {
  if (typeof window === 'undefined') return;
  document.addEventListener(
    'click',
    function (e) {
      // Modifier-keys / middle-click / right-click → laisse le browser faire son truc normal
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      const link = e.target.closest('[data-ps-tcg-variant-picker] a[href]');
      if (!link) return;
      // Si le lien pointe ailleurs (sécurité), on ne touche pas
      const href = link.getAttribute('href');
      if (!href || href.indexOf('?variant=') === -1) return;
      e.preventDefault();
      window.location.replace(href);
    },
    { capture: false }
  );
})();
